import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reactFormatter } from 'react-tabulator';
import ModalPickList from '../../components/common/ModalPickList';
 
let componentProps = null;

const checkEnabled = (cell, isChecked, isMultiChoose) => {
  if (cell) {
    if (isChecked) {
      if (!isMultiChoose) {
        const rows = cell.table.getRows();

        // check has choose other value
        rows.forEach(row => {
          let checkCell = row._row.getCell('PICK_CHECKED');
          if (checkCell.getValue()) {
            checkCell.setValue(0);
            row.deselect();
          }
        });
      }

      cell.setValue(1);
      cell.row.component.select();
    } else {
      cell.setValue(0);
      cell.row.component.deselect();
    }
  }
}

const EnabledBtn = (props) => {
  let iconContent;
  const cellRef = componentProps.isReadonly ? null : props.cell._cell;
  if (props.cell._cell.value) {
    iconContent = <span className='icon-btn-checkbox-p' onClick={() => checkEnabled(cellRef, false, props.isMultiChoose)}></span>;
  } else {
    iconContent = <span className='icon-btn-checkbox-n' onClick={() => checkEnabled(cellRef, true, props.isMultiChoose)}></span>;
  }

  return <div className='area-enabled-icon'>{ iconContent }</div>
}

 
class ModalPickGuestPortal extends Component {
 
  constructor(props) {
    super(props);
 
    componentProps = props;
  }  
 
  // open pick name
  modalName = 'PickGuestPortal'
 
  // open pick title
  modalTitle = 'Select Guest Portal'
 
  // for pick up back data key
  pickUniqueId = 'id'
 
  // pick is multi choose or one choose
  isMultiChoose = false
 
  // open pick list columns
  columns = [
    { title: "", field: "PICK_CHECKED", width: 60, formatter: reactFormatter(<EnabledBtn isMultiChoose={ this.isMultiChoose } />) },
    { title: "ID", field: "id", width: 70 },
    { title: "Name", field: "name", headerFilter: 'input' },
    { title: "Server Ip", field: "serverIp", headerFilter: 'input' },
    { title: "Server Domain", field: "serverDomain", headerFilter: 'input' },
    { title: "Auth Type", field: "authType", headerFilter: 'input' }
  ]
 
  render() {
    const { guestPortalList } = this.props;
 
    return (
      <div className='area-pick-organization'>
          <ModalPickList
            modalName={ this.modalName }
            modalTitle={ this.modalTitle }
            pickUniqueId={ this.pickUniqueId }
            isMultiChoose={ this.isMultiChoose }
            selectMultiCol={ true }
            columns={ this.columns }
            dataList={ guestPortalList }
          >
          </ModalPickList>
      </div>
    )
  }
}
 
const mapStateToProps = (state, ownProps) => {
  return {
    guestPortalList: state.modelReducers.guestPortalList
  }
}
 
export default connect(
  mapStateToProps,
  { }
)(ModalPickGuestPortal)

